import React, { Component } from 'react'
import { View, FlatList, ScrollView, Platform } from 'react-native'
import {
	JDText, JDTouchable, JDImage, JDJumping,
	JDDevice, JDShare, JDMta, JDToast, JDModal, JDTouchableWithoutFeedback
} from '@jdreact/jdreact-core-lib'
import LinearGradient from '@jdreact/jdreact-core-linear-gradient';
import PropTypes from 'prop-types'
import appStyles from '../../App.style'
import styles from './styles'
import constants from '../../constants'

import { queryMaterialCenter, getClueFloatingLayer, getDetailHouseData, queryRecommendHouseResources, insertUserClueWithValidMsg, insertUserClue, queryHouseParamKey, getAdsData } from '../../utils/api'
import * as businessMethods from '../../utils/businessMethods'

import ImgSwiper from './components/imgSwiper/ImgSwiper'
import BigImgSwiper from "./components/imgSwiper/BigImgSwiper"
import SubTitle from "./components/SubTitle"
import HouseDesItem from "./components/HouseDesItem"
import ThumbnailMap from '../../components/ThumbnailMap'
import BrokerItem from "./components/BrokerItem"
import Company from "./components/Company"
import HouseSourceItem from '../../components/HouseSourceItem'
import AdvImage from '../../components/advImage'
import { imgProcess, isPhoneX, formatTimeStamp, isHarmonyWeb, harmonyWebShare, isJDAppWebView } from "../../utils/tools";
import { callPhone } from "../../utils/callPhone";
import WaihuReport from '../../components/waihu/waihuReport'
import LiuZiCompon from "./components/LiuZiCompon"

import { jumpToUrl } from '../../utils/businessMethods'
import { DES_ENCODE } from '../../utils/deviceId'
import JDCNavigationBar from '../../components/JDCNavigationBar';
import { NAVIGATION_BAR_HEIGHT } from '../../utils/steep';

import rightIcon from '../../images/detail/arrow-right.png'
import shareWhite from '../../images/shareWhi.png'
import shareBlack from '../../images/shareBlack.png'
import errpageImg from '../../images/detail/errpage.png'
import brokerCloseImg from '../../images/detail/close_img.png'
import houseChangeIcon from '../../images/detail/housechangeicon.png'
import houseBg from '../../images/detail/house-bg.png'
import liuziIcon from '../../images/detail/yhch.png'
import skeletonImg from '../../images/detail/skeleton.png'


const isWeb = Platform.OS === 'web';
async function getParmkeyFromSku (skuId){
	if ( !skuId) {
		return ''
	} else {
		try {
			const res = await queryHouseParamKey({skuId: skuId})
			if ( res && res.code === 0 && res.id) {
				return res.id
			}else {
				return ''
			}
		} catch (error) {
			return ''
		}
	}
}
class DetailsPage extends Component {
	static contextTypes = {
		router: PropTypes.object
	};
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,	// 是否正在请求数据
			primaryKey: this.props.parmkey,
			cityId: 1,
			isShowImgPreView: false,
			currentImgPage: 1,
			houseDetailsData: [], // 房源详情数据
			houseResourceDTO: {}, // 房源数据
			imgSwiperData: [],
			describeResult: {}, // 房源描述
			brokerResult: {}, // 房源经纪人信息
			footerBrokerInfo: null, // 底部吸顶的经纪人信息
			isShowBrokerInfoImg: false, // 是否展示经纪人信息卡图片
			postBrokerInfoImgUrl: null, // 经纪人信息卡图片的后缀网址
			dataSourceImgUrl: null, // 数据来源图片地址
			plotName: "", // 小区名
			roomDes: "", // 室
			hallDes: "", // 厅
			recommendHouse: [], // 推荐房源 猜你喜欢
			isShowErrMsg: false, // 是否展示错误信息
			errMsg: "", // 提示的错误信息
			callOutFlag: false, // 是否有外呼资格。决定是否显示外呼按钮
			callOutImg: '', // 外呼图片链接
			shwoWaihuWrap: false, // 是否展示外呼弹层,
			firstAdvShow: false,
			firstAdvData: {},
			secondAdvShow: false,
			secondAdvData: {},
			storeId: '', // 门店id 2021-01-14 添加
			showVR: true,//单张图时是否展示VR
			playUrl: '', // 视频播放链接
			surfacePlot: '', //视频封面地址
			isErrPage: false,
			isErrorParmkey: false,
			navBarOpacity: 0,
			houseResourceChangeDTO: {},
			showLiuziBox: false,
			liuziInfo: {
				imgUrl: '',
				advContent: '为了向您提供更精准的咨询服务，您所填写的信息将会同步传递给商家，该商家将尽快与您联系',
				advName: '优惠提醒'
			},
			pageShowMap: false,
			mapLayoutY: 300
		}
		this.swiperRef = null
		this.currentTabIndex = 0
		this.titleView = null
		// 楼层所在的scrollView
		this._scrollView = null
		this.scrollViewHeight = 0
		this.scrollViewContentHeight = 0
		this.recommendHouseParams = {
			pageNo: 1,
			pageSize: 5,
			isLoading: false,
			noMoreData: false
		}
	}
	async componentDidMount() {
		if (!this.state.primaryKey) {
			const id = await getParmkeyFromSku( this.props.skuId)
			this.setState({
				primaryKey: id
			})
		}
		// 登录回来。需要上报心愿单
		const { isReport } = this.props
		this.queryDetailHouseResource(isReport);
		this.getLiuziInfo()
	}
	async componentDidUpdate(prevProps, prevState) {
		if ((prevProps.parmkey && prevProps.parmkey !== this.props.parmkey) || (prevProps.skuId && prevProps.skuId !== this.props.skuId) || (!prevProps.parmkey && this.props.parmkey)) {
			if (!this.props.parmkey) {
				const id = await getParmkeyFromSku( this.props.skuId)
				this.setState({
					primaryKey: id
				},() => {
					this.queryDetailHouseResource();
					this.getLiuziInfo()
					setTimeout(() => {
						// 处理 null is not an object 报错问题，可能的原因是在元素加载之前，就尝试在 JavaScript 中使用 DOM 元素
						this.detailsPageScrollView && this.detailsPageScrollView.scrollTo({ x: 0, y: 0, animated: true });
					}, 0);
				})
			} else {
				this.setState({
					primaryKey: this.props.parmkey
				},() => {
					this.queryDetailHouseResource();
					this.getLiuziInfo()
					setTimeout(() => {
						// 处理 null is not an object 报错问题，可能的原因是在元素加载之前，就尝试在 JavaScript 中使用 DOM 元素
						this.detailsPageScrollView && this.detailsPageScrollView.scrollTo({ x: 0, y: 0, animated: true });
					}, 0);
				})
			}
		}
	}

	getLiuziInfo = () => {
		getClueFloatingLayer({id: 146}).then((res) => {
				const { code, data, success } = res
				if (success && data) {
					this.setState({
						liuziInfo: {
							imgUrl: data.imgUrl || '',
							advContent: data.advContent || '为了向您提供更精准的咨询服务，您所填写的信息将会同步传递给商家，该商家将尽快与您联系',
							advName: data.advName || '优惠提醒'
						}
					})
				} else {
					this.setState({
						liuziInfo: {
							imgUrl:'',
							advContent: '为了向您提供更精准的咨询服务，您所填写的信息将会同步传递给商家，该商家将尽快与您联系',
							advName: '优惠提醒'
						}
					})
				}
			})
			.catch((err) => {
				this.setState({
					liuziInfo: {
						imgUrl:'',
						advContent: '为了向您提供更精准的咨询服务，您所填写的信息将会同步传递给商家，该商家将尽快与您联系',
						advName: '优惠提醒'
					}
				})
			})
	}

	_onMapLayout = ({
		nativeEvent: {
			layout: {height, y},
		},
	}) => {
		this.setState({
			mapLayoutY: y + height/2
		})
	}

	/**
 * @description 处理页面滚动逻辑
 * @memberof Index
 */
	handleTopOnScroll = ({
		nativeEvent: {
			contentOffset: { x, y },
			layoutMeasurement: { height: layoutHeight, width: layoutWidth },
			contentSize: { height, width }
		},
	}) => {
		// 横向滚动，也会触发该事件，要特殊处理一下
		if (isWeb && x > 0) return;
		if (!isWeb) {
			let opacity = (y >= NAVIGATION_BAR_HEIGHT) ? 1 : (Math.floor((y / NAVIGATION_BAR_HEIGHT) * 10) / 10);
			this.navBar && this.navBar.setBgOpacity(opacity);
			this.setState({
				navBarOpacity: opacity,
			})
		}

		if (y > this.state.mapLayoutY - layoutHeight) {
			if (!this.state.pageShowMap) {
				this.setState({
					pageShowMap: true,
				})
			}
		}
		
		if (y + layoutHeight >= (height - 20) && !this.recommendHouseParams.isLoading) {
			this._onRefresh()
		}

	}

	changeState = (item) => {
		this.setState({
			...item
		});
	}
	// 获取房源详情
	queryDetailHouseResource = (isReport = 0) => {
		let primaryKey = this.state.primaryKey || '';
		if (!primaryKey) {
			this.setState({
				isErrorParmkey: true
			});
			return
		}
		this.setState({
			isErrorParmkey: false,
			isLoading:true
		});
		let param = { primaryKey: primaryKey };
		let imgDomainIndex = primaryKey % 7;
		getDetailHouseData(param).then((res) => {
			if (res.code == 0) {
				if (this.state.isErrPage) {
					this.setState({
						isErrPage: false
					});
				}
				if (this.state.isErrorParmkey) {
					this.setState({
						isErrorParmkey: false
					});
				}
				const { houseResourceDTO, callOutFlag = false, callOutImg = '', houseResourceVideoDTO, houseResourceChangeDTO, brokerResult } = res
				const { mainPic } = houseResourceDTO || {}
				let { houseStoreDTO } = res // 门店信息
				this.storeId = houseStoreDTO && houseStoreDTO.storeId || ''
				let cityId = houseResourceDTO && houseResourceDTO.cityCode || 1;
				const { imageUrl, playUrl } = houseResourceVideoDTO || {};

				// 获取到cityID后请求广告坑位数据
				setTimeout(() => {
					const firstId = 2196 // 第一个广告位
					const secondId = 2203 // 第二个广告位
					const param = [
						{ areaId: cityId, id: firstId },
						{ areaId: cityId, id: secondId },
					]
					getAdsData({param: param }).then((res) => {
						const { code, data, msg } = res
						if (code == 0) {
							if (data && data[firstId] && data[firstId].length > 0) {
								// 第一个坑位的数据
								this.setState({
									firstAdvShow: true,
									firstAdvData: data[firstId][0]
								})
							}
							if (data && data[secondId] && data[secondId].length > 0) {
								// 第二个坑位的数据
								this.setState({
									secondAdvShow: true,
									secondAdvData: data[secondId][0]
								})
							}
						}
					})
					.catch((err) => {
					});
				}, 0)

				let imgSwiperData = [];
				// houseResourcePics逻辑是先取主图（mainpic）,主图没有就取默认兜底图，所以它的长度肯定大于0；mainpic可能为空
				imgSwiperData = houseResourceDTO && houseResourceDTO.houseResourcePics.map((item) => {
					return imgProcess(item, "600x600", 70, imgDomainIndex || 1)
				});

				// 有视频房源时
				if (playUrl) {
					let { vrUrl } = houseResourceDTO || {};

					// 封面图，不传封面图用第一张主图替代
					let surfacePlot = imageUrl || imgSwiperData[0];
					this.setState({ surfacePlot })
					// 封面链接
					if (!!vrUrl) {
						if (imgSwiperData.length < 2) {
							if (imgSwiperData[0]) {
								imgSwiperData.push(imgSwiperData[0])
							}
						}
						imgSwiperData.splice(1, 0, surfacePlot)
					} else {
						imgSwiperData.splice(0, 0, surfacePlot)
					}
				}
				if (houseResourceDTO.houseTypePics && houseResourceDTO.houseTypePics.length > 0) {
					let typePics = houseResourceDTO.houseTypePics.map((item) => {
						return imgProcess(item, "600x600", 70, imgDomainIndex || 1)
					});
					imgSwiperData = imgSwiperData.concat(typePics)
				}
				// 埋点添加skuId
				let { plotName, room, hall, skuId, houseResourceId } = houseResourceDTO || {};
				plotName = plotName ? " " + plotName : "";
				const roomDes = room ? room + "室" : "";
				const hallDes = hall ? hall + "厅" : "";

				// 埋点
				JDMta.isReportDefaultPageParam = false;
				JDMta.sendPvData("", `${cityId || ''}_${skuId || ''}_${houseResourceId || ''}`, "SHouse_HouseDetail");

				this.getDataSourceImgUrl(houseResourceDTO.venderName); // 获取数据来源的图片地址
				let footerBrokerInfo;
				let brokerInfo = (brokerResult && brokerResult.resourceBrokerDTOS)? brokerResult.resourceBrokerDTOS : "";
				if (brokerInfo && brokerInfo.length > 0) {
					footerBrokerInfo = brokerInfo[0];
					// for (let i = 0; i < brokerInfo.length; i++) {
					// 	if ( brokerInfo[i].expertBroker) { // 是否是置业专家
					// 		footerBrokerInfo = brokerInfo[i];
					// 		break;
					// 	}
					// }
				}
				let recommendHouse = [];
				if (res.recommendHouseResource && res.recommendHouseResource.resourceDTOS) {
					recommendHouse = res.recommendHouseResource.resourceDTOS;
				}
				const houseShopInfo = businessMethods.getProcessedHouseShopInfo(houseStoreDTO)
				this.setState({
					houseResourceDTO: houseResourceDTO,
					imgSwiperData: imgSwiperData,
					plotName: plotName,
					roomDes: roomDes,
					hallDes: hallDes,
					describeResult: res.describeResult,
					brokerResult: res.brokerResult,				// 经纪人
					footerBrokerInfo: footerBrokerInfo ,	// 吸地经纪人
					// recommendHouse: recommendHouse,
					cityId: cityId,
					callOutFlag, // 是否有外呼资格
					callOutImg, // 外呼按钮图片
					houseShopInfo, // 门店信息
					playUrl, // 视频地址
					houseResourceChangeDTO: houseResourceChangeDTO || {}
				}, () => {
					// 是否外呼回来，需要进行上报的
					if (isReport == 1) {
						this.reportWish()
					}
					// 获取到数据后web端需要初始化分享内容
					if (Platform.OS === 'web') {
						const { title, url, shareImg, content } = this.getShareContent()
						if (isJDAppWebView() && typeof JdShare !== 'undefined' && !isHarmonyWeb()) {
							JdShare.setShareInfo({
								title, url, shareImg, content,
								img: shareImg,
								channel: '',
								callback: null,
								clickcallback: null,
								qrparam: null,
								timeline_title: '',
							})
						}
						if (isHarmonyWeb()) {
							harmonyWebShare({
								title, url, shareImg, content
							})
						}
						document.title = title
					}
					// 请求猜你喜欢数据
					this._onRefresh()
				})
			} else if(res.code == 10007){
				this.setState({
					isErrorParmkey: true
				});
			} else {
				this.setState({
					isErrPage: true
				});
			}
			// 解决ios端的h5页面偶尔不能滚动到顶部的问题
			if (Platform.OS === "web") {
				let u = navigator.userAgent, app = navigator.appVersion;
				let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
				if (isIOS) {
					setTimeout(() => {
						this.detailsPageScrollView.scrollTo({ x: 0, y: 0, animated: true });
					}, 0)
				}

			}
		}).catch(err => {
			this.setState({
				isErrPage: true
			});
			console.log(err, "query house resource detail err");
		}).finally (()=>{
			this.setState({
				isLoading:false
			})
		})
	};

	// 猜你喜欢 加载更多
	_onRefresh = () => {
		let { addressLat, addressLon, cityCode } = this.state.houseResourceDTO || {}
		this.recommendHouseParams.isLoading = true
		queryRecommendHouseResources({
			pageNum: this.recommendHouseParams.pageNo,
			pageSize: this.recommendHouseParams.pageSize,
			// 经度
			addressLat: addressLat,
			// 维度
			addressLon: addressLon,
			// 房源主键
			houseResourceId: this.state.primaryKey,
			// 二级地址code
			secondCode: cityCode
		}).then(res => {
			if (res.code === 0 && res.resourceDTOS && res.resourceDTOS.length) {
				this.setState({
					recommendHouse: this.state.recommendHouse.concat(res.resourceDTOS)
				})
			}
			// 设置请求参数
			this.recommendHouseParams.pageNo += 1;
			if (this.recommendHouseParams.pageNo > totalPage) {
				this.recommendHouseParams.noMoreData = true;
			}
			this.recommendHouseParams.isLoading = false;
		}).catch(err => {
			this.recommendHouseParams.isLoading = false;
			this.recommendHouseParams.noMoreData = true;
		})
	}

	getDataSourceImgUrl(venderName) {
		queryMaterialCenter("03014313").then((res) => {
			return res.json();
		}).then((res) => {
			if (res.code == 0 && res.advertInfos && res.advertInfos[0]) {
				let usedData = res.advertInfos[0].list || [];
				usedData.forEach((item) => {
					let pictureUrl = "";
					if (item.desc == venderName) {
						if (!/^http/.test(item.pictureUrl)) {
							pictureUrl = 'https:' + item.pictureUrl;
						} else {
							pictureUrl = item.pictureUrl;
						}
						this.setState({ dataSourceImgUrl: pictureUrl });
					}
				});
			}
		}).catch(err => console.log("net err"));
	}
	// 跳转到房源描述页
	jumpDesPage = () => {
		JDMta.sendClickData("SHouse_AllHouseDescribe", this.state.cityId + "", "", "", "", "", "SHouse_HouseDetail", "");
		this.context.router['toHouseDes']({
			parmkey: this.state.primaryKey,
			cityid: this.state.cityId
		});
	};
	// 跳转到小区详情
	jumpToDistrictDetail = (plotId) => {
		JDMta.sendClickData("SHouse_HouseDetail", this.state.cityId + "", "", "", "", "", "SHouse_HouseDetail", "");
		if (plotId) {
			JDJumping.jumpToWeb(constants.housePriceUrl + plotId)
				.catch(err => console.log(err, "跳转小区详情页失败"));
		}
	};
	jumpMap = (addressLat, addressLon) => {
		JDMta.sendClickData("SHouse_MatchingMap", this.state.cityId + "", "", "", "", "", "SHouse_HouseDetail", "");
		if (addressLat && addressLon) {
			JDJumping.jumpToWeb(`${constants.esfUrl}mapdetail?maplat=${DES_ENCODE(addressLat)}&maplon=${DES_ENCODE(addressLon)}`)
				.catch(err => console.log(err, "跳转周边配套地图页失败"));
		}
	};
	jumpBrokerPage = () => {
		this.context.router['toBrokerInfo']({
			parmkey: this.state.primaryKey || ''
		});
	};
	// 跳转到门店地图页
	jumpShopMap = (latLon) => {
		const { houseResourceDTO } = this.state
		const { skuId } = houseResourceDTO || {}
		JDMta.sendClickData("SHouse_ShopClick", this.state.cityId + "", "", "", "", "", "SHouse_HouseDetail", "");
		// 跳转门店详情页
		const { lat, lon } = latLon || {}
		const postUrl = `storesdetail?parmkey=${this.state.primaryKey}&lat=${lat}&lon=${lon}&storeId=${this.storeId}&skuId=${skuId || ''}`
		const preAccessUrl = constants.esfUrl
		const url = preAccessUrl + postUrl
		jumpToUrl(url)
		return
	};
	viewBrokerInfo = (postBrokerInfoImgUrl) => {
		this.setState({
			isShowBrokerInfoImg: true,
			postBrokerInfoImgUrl: postBrokerInfoImgUrl
		});
	};
	closeBrokerInfoImg = () => {
		this.setState({
			isShowBrokerInfoImg: false
		});
	};
	// 渲染房源描述数据
	renderHouseDesItem = (desItemInfo) => {
		let houseDesItem = desItemInfo.item;
		let cityId = this.state.cityId;
		return (<HouseDesItem houseDesItem={houseDesItem} cityId={cityId}></HouseDesItem>)
	};
	_separator() {
		return <JDText style={styles.rowLine}></JDText>
	}
	// 渲染联系经纪人模块
	renderBrokerItem = (brokerInfo, index) => {
		const { houseResourceDTO } = this.state;
		let { skuId, title } = houseResourceDTO || {};
		return (<BrokerItem isFooter={false} index={brokerInfo.index} skuid={skuId} spuName={title} brokerInfo={brokerInfo.item} cityId={this.state.cityId} viewBrokerInfo={this.viewBrokerInfo}></BrokerItem>)
	};
	// 渲染房源描述模块（会重复渲染一次？）
	renderRecommendHouseItem = (recommendHouseItem) => {
		return (
			<JDTouchable onPress={() => this.toRecommendHouse(recommendHouseItem.item.houseResourceId)}>
				<HouseSourceItem recommendHouseItem={recommendHouseItem.item} index={recommendHouseItem.index} />
			</JDTouchable>
		)
	};
	// 跳转到房源描述页
	toRecommendHouse = (houseResourceId) => {
		JDMta.sendClickData("SHouse_DetailRecomHouse", this.state.cityId + "", "", "", "", "", "SHouse_HouseDetail", "");
		if(isWeb){
			this.setState({
				recommendHouse: [],
				houseResourceDTO:{}
			}, () => {
				this.context.router['toDetailsPage']({
					parmkey: houseResourceId,
					isReport: 0, // 是否需要上报心愿单
				});
			})
		}else{
			this.context.router['toDetailsPage']({
				parmkey: houseResourceId,
				isReport: 0, // 是否需要上报心愿单
			});
		}
	};
	// 轮播图打开大图预览
	enterImgPreview = (currentIndex) => {
		let {
			vrUrl,
		} = this.state.houseResourceDTO || {};
		let { showVR } = this.state;
		if (currentIndex === 0 && vrUrl && showVR) {
			JDJumping.jumpToWeb(vrUrl).catch(err => {
				console.log('跳转VR链接失败: ', err)
			})
			return
		}
		this.setState({
			isShowImgPreView: true,
			currentImgPage: currentIndex
		});
	};
	// 轮播图关闭大图预览
	quitImgPreview = () => {
		this.setState({
			isShowImgPreView: false
		});
	};
	// 获取分享的数据
	getShareContent = () => {
		const { primaryKey } = this.state
		let { plotName, roomDes, hallDes, houseResourceDTO = {} } = this.state

		let {
			cityAreaName = '', tradingAreaName = '', orientation = '',
			totalPrice, structureArea, houseResourcePics = [],
		} = houseResourceDTO

		totalPrice = totalPrice ? totalPrice + "万" : "";
		structureArea = structureArea ? structureArea + "平" : "";
		let gang = cityAreaName && tradingAreaName ? '-' : '';

		return {
			title: plotName + roomDes + hallDes + totalPrice + structureArea,
			url: `${constants.esfrUrl}detailsPage?parmkey=${primaryKey}`,
			shareImg: `https://img1.360buyimg.com/n4/${houseResourcePics[0]}`,
			content: cityAreaName + gang + tradingAreaName + plotName + roomDes + hallDes + totalPrice + structureArea + orientation,
		}
	}
	telCall = (footerBrokerInfo) => { // 拨打底部的电话咨询
		callPhone(footerBrokerInfo);
	};
	_onHide = () => { // 隐藏错误提示
		this.setState({
			errMsg: null,
			isShowErrMsg: false
		});
	};
	// 点击外呼按钮
	// waihuBtnTap = () => {
	// 	JDMta.sendClickData('SHouse_FloatIcon', `${this.state.cityId}`, '', '', '', '', 'SHouse_HouseDetail', '')

	// 	this.setState({
	// 		shwoWaihuWrap: !!!this.state.shwoWaihuWrap
	// 	})
	// }
	// 广告楼层点击埋点
	advImageMping = (eventId) => {
		if (eventId) {
			JDMta.sendClickData(eventId, `${this.state.cityId}`, '', '', '', '', 'SHouse_HouseDetail', '')
		}
	}

	showErrFunc = (msg) => {
		this.setState({
			errMsg: msg,
			isShowErrMsg: true
		}, ()=> setTimeout(()=>{
			this._onHide()
		},3000))
	}
	// 点击优惠提醒
	handleLiuziIcon = () =>{
		const {houseResourceDTO} = this.state
		this.setState({showLiuziBox: true})
		let json_param = JSON.stringify({
			skuid: houseResourceDTO ? houseResourceDTO.skuId : '',
			venderid: houseResourceDTO.venderId,
		})
		JDMta.sendClickDataWithJsonParam("SHouse_HouseDetail_consult_float",'',	"", 	"https://esfr.m.jd.com/housedetail",	"",	"", "SHouse_HouseDetail",	"", json_param);
	}
	liuziConfirm = (obj) => {
		const { skuId, venderId, title, spuId, cityName } = this.state.houseResourceDTO || {}

		let paramsObj = {
			...obj,
			skuId,
			venderId,
			spuName: title,
			spuId: this.state.primaryKey || '',
			type: 4, // 活动留资5-不校验重复留资，优惠是4-校验重复留资
			clueCityName:cityName,	// 城市名称
		}
		if (paramsObj && paramsObj.validMsg) {
			insertUserClueWithValidMsg(paramsObj).then((res) => {
					const { code, data, msg } = res
					let msagess = '当前活动太火爆啦！请稍后重试！'
					if (code === '1' || code === '120001') {
						msagess = code === '1' ? '订阅成功' : '您已添加提醒,无需重复添加'
						this.showErrFunc(msagess)
						this.setState({showLiuziBox: false})
					} else {
						msagess = msg || '当前活动太火爆啦！请稍后重试！'
						this.showErrFunc(msagess)
					}
					
				})
				.catch((err) => {
					this.showErrFunc('当前活动太火爆啦！请稍后重试！')
				});
		} else {
			insertUserClue(paramsObj).then((res) => {
					const { code, data, msg } = res
					let msagess = '当前活动太火爆啦！请稍后重试！'
					if (code === '1' || code === '120001') {
						msagess = code === '1' ? '订阅成功' : '您已添加提醒,无需重复操作'
						this.showErrFunc(msagess)
						this.setState({showLiuziBox: false})
					} else {
						msagess = msg || '当前活动太火爆啦！请稍后重试！'
						this.showErrFunc(msagess)
					}
					
				})
				.catch((err) => {
					this.showErrFunc('当前活动太火爆啦！请稍后重试！')
				});
		}

	}
	// 切换外呼弹层的显示
	// toggleWaihuWrap = () => {
	// 	this.setState({
	// 		shwoWaihuWrap: !!!this.state.shwoWaihuWrap
	// 	})
	// }
	// 上报心愿单逻辑
	reportWish = () => {
		// 组装参数
		const {
			plotName = '',
			hallDes = '', roomDes = '',
			houseResourceDTO = {}
		} = this.state

		const {
			structureArea = '',
			totalPrice = '',
			tradingAreaName = '',
			cityName = '',
			cityAreaName = '',
		} = houseResourceDTO

		const wishInfo = {
			'2317': cityName, // 城市
			'2318': cityAreaName, // 区县
			'2319': tradingAreaName, // 商圈
			'2320': plotName, // 小区名称
			'2321': `${totalPrice}`, // 房源总价
			'2322': roomDes + hallDes, // 户型
			'2323': `${structureArea}`, // 建筑面积
			'2324': 'https://esfr.m.jd.com', // 房源链接
		}

		const reportParams = {
			'wishTypeId': '565',
			'wishSourceType': '1',
			'wishSourceUrl': 'https://esfr.m.jd.com',
			'wishSourceId': '2304',
			'vendorId': '',
			// 'jda': getCookie('__jda'),
			'wishInfo': JSON.stringify(wishInfo),
			// 'uuid': new Fingerprint({canvas: true}).get(),
			'smsCode': '',
		}

		// web 平台取链接值
		if (Platform.OS == 'web') {
			wishInfo['2324'] = (location && location.origin) || ''
			reportParams['wishSourceUrl'] = (location && location.href) || ''
		} else {
			const { primaryKey = '' } = this.state
			reportParams['wishSourceUrl'] = `${reportParams['wishSourceUrl']}/detailsPage?parmkey=${primaryKey}`
		}

		// 成功或失败都隐藏弹层
		WaihuReport({
			// 如果展示则关闭
			success: () => {
				if (this.state.shwoWaihuWrap) {
					this.setState({
						shwoWaihuWrap: false
					})
				}
			},
			reportParams
		})
	}
	render() {
		let {
			imgSwiperData, isShowImgPreView, isShowBrokerInfoImg,
			postBrokerInfoImgUrl, primaryKey, brokerResult, plotName,
			roomDes, hallDes, dataSourceImgUrl, footerBrokerInfo,
			shwoWaihuWrap, callOutFlag, callOutImg, // 外呼相关
			firstAdvShow, firstAdvData, secondAdvShow, secondAdvData, // 广告位相关
			showVR,
			houseShopInfo, // 门店信息
			playUrl,  //视频信息
			surfacePlot, //封面图
			isErrPage,
			isErrorParmkey,
			navBarOpacity,
			houseResourceChangeDTO,
			showLiuziBox,
			houseResourceDTO,
			liuziInfo,
			isLoading,
			pageShowMap
		} = this.state
		let {
			houseResourcePics,
			totalPrice, unitPrice, title, labels,
			housePutawayTime, structureArea,
			floorLabel, totalFloor, buildYear, orientation, fitmentType, plotAddress = '',
			plotId, // 小区id
			addressLat, addressLon,  // 地址经纬度
			venderName, houseUpdateTime,
			cityCode,
			houseTypePics,
			vrUrl,
			saleHouseResourceCount,
			estateType,
			tradeAffiliation,
			houseTerm,
			elevatorLabel,
			venderId
		} = houseResourceDTO || {};
		// 根据primaryKey的值，来决定访问图片的地址
		let imgDomainIndex = primaryKey % 7;
		const isHouseTypeLength = houseTypePics ? houseTypePics.length : 0

		const {
			resourceDescribeDTOS, //  房源描述数据
			totalCount // 房源描述数据总条数
		} = this.state.describeResult || {};
		let brokerTotalCount = 0;
		let resourceBrokerDTOS = null;
		if (brokerResult) {
			brokerTotalCount = brokerResult.totalCount || 0;
			brokerResult.resourceBrokerDTOS && (resourceBrokerDTOS = brokerResult.resourceBrokerDTOS);
		}
		let titleName = plotName + roomDes + hallDes;
		titleName ? (titleName = titleName.slice(0, 11) + '...') : (titleName = "房源详情");
		// const shopLatLon = (houseShopInfo || {}).latLon // 门店所在经纬度
		const shopLatLon = buildLatLon((houseShopInfo || {}).latLon) // 门店所在经纬度
		function buildLatLon(latLon) {
			const { lat, lon } = latLon || {}
			if (!lat) return {}
			return {
				lat: DES_ENCODE(lat),
				lon: DES_ENCODE(lon),
			}
		}
		const isNavBarDarkStyle = isWeb || navBarOpacity > 0.8;

		
		// 渲染底部吸底
		const renderSuctionBottom = () =>{
			// footerBrokerInfo
			const {houseResourceDTO,cityId,describeResult} = this.state
			// 经纪人底部
			const renderBrokerInfo = <View style={[styles.brokerFooter, isPhoneX() ? { paddingBottom: 17, height: JDDevice.getRpx(150) + 17 } : '']}>
				<BrokerItem 
					index={0} 
					isFooter={true}
					skuid={houseResourceDTO ? houseResourceDTO.skuId : ''} 
					cityId={cityId} 
					brokerInfo={footerBrokerInfo} 
					viewBrokerInfo={this.viewBrokerInfo} 
				/>
			</View>
			// 公司底部
			const renderCompany = <View style={[styles.brokerFooter, isPhoneX() ? { paddingBottom: 17, height: JDDevice.getRpx(150) + 17 } : '']}>
				<Company 
					venderId={venderId}
					handleConsult={this.handleLiuziIcon} 
					companyInfo={{
						companyLogo:houseResourceDTO.companyLogo,
						companyDes:describeResult.resourceDescribeDTOS && describeResult.resourceDescribeDTOS[0]? describeResult.resourceDescribeDTOS[0].companyDes:''
					}}/>
			</View>
			if(brokerResult && brokerResult.hide) return renderCompany
			return footerBrokerInfo ? renderBrokerInfo : null	//  hide:true(开启Ducc配置) | false(未开启Ducc配置)
		}
		return (
			<View style={styles.page}>
				<JDCNavigationBar
					// renderMiddle={isNavBarDarkStyle ? titleName : ''}
					renderMiddle={() => <View style={styles.navMiddBox}>
						<JDText style={styles.navMiddText}>{isNavBarDarkStyle ? titleName : ''}</JDText>
						<View style={styles.navShareView}>
							<JDTouchable style={styles.shareIconBox} key="shareIcon"
								onPress={() => {
									JDMta.sendClickData('SHouse_DetailShare', `${this.state.cityId}`, '', '', '', '', 'SHouse_HouseDetail', '')

									const { title, url, shareImg, content } = this.getShareContent()
									JDShare.showShareDialog(url, title, content, shareImg)
								}}
							>
								<JDImage source={isNavBarDarkStyle ? shareBlack : shareWhite} style={styles.shareIcon} />
							</JDTouchable>
						</View>
					</View>}
					showMoreButton={true}
					containerStyle={{}}
					barContainerStyle={{ backgroundColor: 'transparent' }}
					bgStyle={{}}
					ref={ref => this.navBar = ref}
					theme={isNavBarDarkStyle ? 'dark' : 'light'}
				/>
				<JDModal visible={isShowBrokerInfoImg} transparent={true}>
					<View style={styles.brokerInfoBox}>
						<JDTouchable onPress={this.closeBrokerInfoImg}>
							<View style={styles.brokerInfoCon}>
								<View>
									<JDImage
										style={styles.brokerInfoImg}
										source={{ uri: imgProcess(postBrokerInfoImgUrl, "800x800", 60, imgDomainIndex) }}
									></JDImage>
								</View>
								<View style={styles.brokerInfoImgClose}>
									<JDImage
										style={styles.imgCloseIcon}
										source={brokerCloseImg}
									></JDImage>
								</View>
							</View>
						</JDTouchable>
					</View>
				</JDModal>
				<JDModal visible={showLiuziBox} transparent={true}>
					<View style={styles.brokerInfoBox}>
						<JDTouchableWithoutFeedback
							contentContainerStyle={styles.liuziBigWindow}
							onPress={()=> {
								this.setState({
									showLiuziBox: false
								})
							}}>
							
						</JDTouchableWithoutFeedback>
						<LiuZiCompon liuziInfo={liuziInfo} close={() => {	this.setState({showLiuziBox: false}) }} propOnConfirm={this.liuziConfirm}></LiuZiCompon>
					</View>
				</JDModal>
				
				{/* <JDModal visible={true} transparent={true}> */}
				{isLoading && <View style={styles.skeletonpageBox}>
						<JDImage
							style={styles.skeletonImg}
							source={skeletonImg}
						></JDImage>
					</View>
				}
				{isErrPage && <View style={styles.errpageBox}>
					<View>
						<JDImage
							style={styles.errpageImg}
							source={errpageImg}
						></JDImage>
					</View>
					<JDText style={styles.errpageText}>当前活动太火爆啦！请稍后重试！</JDText>
					<JDText style={styles.errpageTip}>请点击按钮重新加载</JDText>
					<JDTouchable onPress={this.queryDetailHouseResource}>
						<View style={styles.errpageBtn}>
							<JDText style={styles.errpageBtnText}>重新加载</JDText>
						</View>
					</JDTouchable>
				</View>}
				{isErrorParmkey && <View style={styles.errpageBox}>
					<View>
						<JDImage
							style={styles.errpageImg}
							source={errpageImg}
						></JDImage>
					</View>
					<JDText style={styles.errpageText}>该房源不存在，或已下架</JDText>
				</View>}
				{/* </JDModal> */}


				{/*展示大图轮播*/}
				{
					isShowImgPreView && (
						<BigImgSwiper
							imgSwiperData={imgSwiperData}
							currentImgPage={this.state.currentImgPage}
							quitImgPreview={this.quitImgPreview}
						></BigImgSwiper>
					)
				}
				{/* 2022年03月31日18:25:44 屏蔽入口 */}
				{/* { callOutFlag && <WaihuBtn onClick={this.waihuBtnTap} btnImageLink={callOutImg} />} */}
				{
					// shwoWaihuWrap && <WaihuWrap onAgree={this.reportWish} onClose={this.toggleWaihuWrap} />
				}

				<ScrollView
					style={[(isShowBrokerInfoImg || isShowImgPreView) ? styles.lockScroll : null, (isErrorParmkey || isErrPage ? {'display':'none'} : null )]}
					ref={(view) => { this.detailsPageScrollView = view }}
					onScroll={this.handleTopOnScroll}		
				>
					<View style={
						footerBrokerInfo ? (isPhoneX() ? { paddingBottom: JDDevice.getRpx(150) + 17 } : { paddingBottom: JDDevice.getRpx(150) }) : null}>
						{
							houseResourcePics && (
								<ImgSwiper
									imgSwiperData={imgSwiperData || []}
									cityId={cityCode}
									previewAble={true}
									isVR={!!vrUrl}
									// isVR={false}
									isHouseTypeLength={isHouseTypeLength}
									showVR={showVR}
									isVideo={!!playUrl}
									surfacePlot={surfacePlot}
									playUrl={playUrl}
									changeState={this.changeState}
									enterImgPreview={this.enterImgPreview}
								></ImgSwiper>
							)
						}
						<View style={styles.paddingDiv}>
							{/*楼盘信息模块*/}
							<View style={styles.desInfoWrap}>
								<View style={styles.container}>
									{/* title信息 */}
									<View style={styles.container}>
										<JDText style={styles.desInfoTitle} numberOfLines={2}>{title}</JDText>
									</View>
									{/* 标签信息 */}
									<View style={[styles.desInfoLabelWrap, styles.containRow, appStyles.justifyStart]}>
										{
											labels && labels.slice(0, 5).map((label, index) => {
												if(label==='店长推荐'){
													return <LinearGradient
															colors={['#999fbb', '#b7bdd4','#c3c9db']} // 渐变颜色数组
															start={{ x: 0, y: 0 }} // 渐变起始点坐标
															end={{ x: 1, y: 1 }} // 渐变结束点坐标
															style={ styles.desInfoLabelLight} // 样式
															key={'JDText_' + index}
														>
															<JDText style={{color: '#fff', fontSize: JDDevice.getRpx(22)}}>{label}</JDText>
														</LinearGradient>
												}
												return <JDText style={styles.desInfoLabel} key={'JDText_' + index}>{label}</JDText>
											})
										}
									</View>
								</View>
								<View style={[appStyles.alignStart, styles.containRow, styles.desInfoMainWrap]}>
									<View style={[styles.desInfoMainWrapCota1]}>
										{
											(totalPrice == -1 || !totalPrice) ?
											(<JDText style={styles.desInfoDetailMainValue}>--</JDText>)
											:(
												<JDText style={styles.desInfoDetailMainValue}>
													{totalPrice}
													<JDText style={styles.wan}>万</JDText>
												</JDText>
											)
										}
										<JDText style={styles.desInfoDetailMainKey}>总价</JDText>
									</View>
									<View style={[styles.desInfoMainWrapCota2]}>
										{
											(roomDes + hallDes) ? 
											(
												<JDText style={styles.desInfoDetailMainValue}>
													{this.state.houseResourceDTO.room}
													<JDText style={styles.wan}>室</JDText>
													{this.state.houseResourceDTO.hall}
													<JDText style={styles.wan}>厅</JDText>
												</JDText>
											)
											: (
												<JDText style={styles.desInfoDetailMainValue}>--</JDText>
											)
										}
										
										<JDText style={styles.desInfoDetailMainKey}>户型</JDText>
									</View>
									<View>
										<View style={styles.squareWrapper}>
											<JDText style={styles.desInfoDetailMainValue}>{structureArea ? `${structureArea}m` : "--"}
											</JDText>
											{structureArea && (<JDText style={styles.square}>2</JDText>)}
										</View>
										<JDText style={styles.desInfoDetailMainKey}>建筑面积</JDText>
									</View>
								</View>

								{/* 户型信息 */}
								<View style={[styles.desInfoDetailWrap, appStyles.alignStart, styles.containRow]}>
									<View style={[styles.containRow, styles.desInfoDetailCota]}>
										<JDText style={styles.desInfoDetailKey}>单价</JDText>
										<View style={[styles.desInfoDetailValue,styles.squareWrapper]}>
											<JDText style={[styles.desInfoDetailPrice]}>{unitPrice ? `${unitPrice}/m` : "--"}</JDText>
											{unitPrice && (<JDText style={styles.squareUnit}>2</JDText>)}
										</View>
									</View>
									<View style={[styles.containRow, styles.desInfoDetailCota, styles.desInfoEven]}>
										<JDText style={styles.desInfoDetailKey}>年代</JDText>
										<JDText style={styles.desInfoDetailValue}>{buildYear || "--"}</JDText>
									</View>
									<View style={[styles.containRow, styles.desInfoDetailCota]}>
										<JDText style={styles.desInfoDetailKey}>楼层</JDText>
										<JDText style={styles.desInfoDetailValue}>{floorLabel ? (floorLabel + (totalFloor ? `/${totalFloor}层` : "")) : "--"}</JDText>
									</View>
									<View style={[styles.containRow, styles.desInfoDetailCota, styles.desInfoEven]}>
										<JDText style={styles.desInfoDetailKey}>用途</JDText>
										<JDText style={styles.desInfoDetailValue}>{estateType || "--"}</JDText>
									</View>
									<View style={[styles.containRow, styles.desInfoDetailCota]}>
										<JDText style={styles.desInfoDetailKey}>朝向</JDText>
										<JDText style={styles.desInfoDetailValue}>{orientation || "--"}</JDText>
									</View>
									<View style={[styles.containRow, styles.desInfoDetailCota, styles.desInfoEven]}>
										<JDText style={styles.desInfoDetailKey}>权属</JDText>
										<JDText style={styles.desInfoDetailValue}>{tradeAffiliation || "--"}</JDText>
									</View>
									<View style={[styles.containRow, styles.desInfoDetailCota]}>
										<JDText style={styles.desInfoDetailKey}>装修</JDText>
										<JDText style={styles.desInfoDetailValue}>{fitmentType || "--"}</JDText>
									</View>
									<View style={[styles.containRow, styles.desInfoDetailCota, styles.desInfoEven]}>
										<JDText style={styles.desInfoDetailKey}>产证</JDText>
										<JDText style={styles.desInfoDetailValue}>{houseTerm || "--"}</JDText>
									</View>
									<View style={[styles.containRow, styles.desInfoDetailCota]}>
										<JDText style={styles.desInfoDetailKey}>电梯</JDText>
										<JDText style={styles.desInfoDetailValue}>{elevatorLabel ? (elevatorLabel === 1 ? '有': '无') : "--"}</JDText>
									</View>
									<View style={[styles.containRow, styles.desInfoDetailCota, styles.desInfoEven]}>
									</View>
									<View style={styles.containRow}>
										<View style={[styles.desInfoDetailSqurDetailWrap, appStyles.flexCenter]}>
											<JDText style={styles.desInfoDetailKey}>小区</JDText>
											<JDText style={[styles.desInfoDetailValue,styles.desInfoDetailTextFlexOne]}>{plotName && plotName.trim() || "--"}</JDText>
										</View>
										<JDTouchable onPress={() => { this.jumpToDistrictDetail(plotId) }} style={appStyles.flexCenter}>
											<View style={styles.desInfoDetailJumpBtn}>
												<JDText style={styles.desInfoDetailJumpBtnText}>在售{saleHouseResourceCount}套</JDText>
												<JDImage source={rightIcon} style={styles.desInfoDetailJumpBtnIcon} />
											</View>
										</JDTouchable>
									</View>
									<View style={[styles.containRow, styles.desInfoDetailCota, styles.desInfoDetailFlexOne, { justifyContent: "flex-start" }]}>
										<JDText style={styles.desInfoDetailKey}>地址</JDText>
										<JDText style={[styles.desInfoDetailValue, styles.desInfoDetailTextFlexOne]}>{plotAddress || "--"}</JDText>
									</View>
								</View>
							</View>
							{/*门店信息模块*/}
							{/* {
								houseShopInfo && (
									<View style={styles.moduleBox}>
										<SubTitle titleName="门店"  styleObj={{marginVertical: JDDevice.getRpx(32)}} />
										<ShopInfo houseShopInfo={houseShopInfo} jumpFunc={() => {
											this.jumpShopMap(shopLatLon)
										}} />
									</View>
							)
						} */}
							{/* 房源描述模块 */}
							{
								resourceDescribeDTOS && (
									<View style={styles.moduleBox}>
										<JDImage source={houseBg} style={styles.houseBg} />
										<SubTitle titleName="房源情况" linkDes={totalCount > 3 ? `全部 ${totalCount}条` : ''} jump={this.jumpDesPage}></SubTitle>
										<FlatList
											style={styles.boxMargin}
											data={resourceDescribeDTOS}
											renderItem={this.renderHouseDesItem}
											ItemSeparatorComponent={this._separator}
											keyExtractor={(item, index) => 'houseDes_' + index}
										/>
									</View>
								)
							}
							{/* 咨询底价的广告信息 */}
							{
								firstAdvShow && <View style={styles.secondAdvWrap}>
									<AdvImage advData={firstAdvData} beforeJump={() => {
										this.advImageMping('SHouse_Ad1')
									}} />
								</View>
							}
							{/* 小区及周边模块 */}
							{
								addressLat && addressLon && (
									<View style={styles.aroundBox} onLayout={this._onMapLayout} ref={ref => this.mapBoxRef = ref}>
										<SubTitle titleName="位置及周边" linkDes='查看完整配套' jump={() => { this.jumpMap(addressLat, addressLon) }} />
										<ThumbnailMap pageShowMap={pageShowMap} addressLat={addressLat} addressLon={addressLon} plotName={plotName} plotAddress={plotAddress}
											onMapPress={() => { this.jumpMap(addressLat, addressLon) }} />
									</View>
								)
							}
							{/* 房源变化模块 */}
							{
								!!houseResourceChangeDTO.housePutawayTime && (
									<View style={styles.aroundBox}>
										<SubTitle titleName="房源变化" linkDes={footerBrokerInfo ? '咨询经纪人' : ''} jump={() => {
											let json_param = JSON.stringify({
												skuid: this.state.houseResourceDTO ? this.state.houseResourceDTO.skuId + '' : '',
												cityid: this.state.cityId + '',
												broker_name: footerBrokerInfo.name || ''
											})
											JDMta.sendClickDataWithJsonParam("SHouse_HouseDetail_broker",'',	"", 	"https://esfr.m.jd.com/housedetail",	"",	"", "SHouse_HouseDetail",	"", json_param);
											this.telCall(footerBrokerInfo)
											}} />
										<View style={styles.houseChangeBox}>
											<JDImage source={houseChangeIcon} style={styles.houseChangeIcon} />
											<JDText style={styles.houseChangeText}>{formatTimeStamp(houseResourceChangeDTO.housePutawayTime, true, '-')} 房源挂牌</JDText>
										</View>
										{houseResourceChangeDTO.count > 0 && <View style={styles.houseChangeBox}>
											<View style={styles.houseChangeLine} />
											<JDImage source={houseChangeIcon} style={styles.houseChangeIcon} />
											<JDText style={styles.houseChangeText}>最近3个月调价{houseResourceChangeDTO.count}次</JDText>
										</View>}
									</View>
								)
							}
							{/* 联系经纪人模块 */}
							{
								resourceBrokerDTOS && resourceBrokerDTOS.length > 0 && (
									<View style={styles.brokerContainer}>
										<SubTitle titleName="经纪人服务" linkDes={brokerTotalCount > 3 ? `查看更多` : ''} jump={this.jumpBrokerPage} />
										<FlatList
											data={resourceBrokerDTOS.slice(0, 3)}
											renderItem={this.renderBrokerItem}
											keyExtractor={(item, index) => 'broker_' + index}
											style={{ paddingLeft: JDDevice.getRpx(28), paddingRight: JDDevice.getRpx(30) }}
										/>
									</View>
								)
							}
							{
								secondAdvShow ? (
									<View style={styles.secondAdvWrap}>
										<AdvImage advData={secondAdvData} beforeJump={() => {
											this.advImageMping('SHouse_Ad1')
										}} />
									</View>
								) : null
							}
							{/*推荐房源*/}
							{
								this.state.recommendHouse && this.state.recommendHouse.length > 0 && (
									<View style={styles.houseSourceContainer}>
										<SubTitle titleName="猜你喜欢"/>
										<View style={{ marginTop: -JDDevice.getRpx(30), marginBottom: JDDevice.getRpx(15) }}>
											<FlatList
												data={this.state.recommendHouse}
												renderItem={this.renderRecommendHouseItem}
												ItemSeparatorComponent={this._separator}
												keyExtractor={(item, index) => 'houseDes_' + index}
											/>
										</View>
									</View>
								)
							}
						</View>
					</View>
				</ScrollView>
				{/*吸底联系经纪人底部*/}
				{ renderSuctionBottom() }
				{/*留资浮起层*/}
				{
					!!venderId && (
						<View style={styles.liuziView}>
							<JDTouchable style={styles.liuziBox} key="liuzi"
								onPress={this.handleLiuziIcon}
							>
								<JDImage source={liuziInfo.imgUrl ? { uri: liuziInfo.imgUrl } : liuziIcon} style={styles.liuziIcon} />
							</JDTouchable>
						</View>
					)
				}
				{
					isPhoneX() && (<View style={styles.iphoneXDiv} />)
				}
				{/*错误信息提示模块*/}
				<JDToast show={this.state.isShowErrMsg} onHide={this._onHide} style={styles.toastStyle} mode={JDToast.MODE.MODAL}>
					{this.state.errMsg}
				</JDToast>
			</View>
		)
	}
}

export default DetailsPage
